// extracted by mini-css-extract-plugin
export default {"dialog":"TwoOptionsDialog_dialog__E+ud2"};